import React from 'react';
import { onRequestPhoneCall } from 'src/helpers/validationHelper';
import CategoryPill from '../CategoryPill/CategoryPill';
import './Tenant.scss';

// Todo: Further define these interfaces as we continue to sprinkle in TypeScript to this project.
interface CategoryPillsProps {
  items?: any[];
}

// CategoryPills component to render the pills container.
const CategoryPills: React.FC<CategoryPillsProps> = ({ items }) => {
  if (!items || !items.length) return null;

  return (
    <div className="tenant_pills-container">
      {items.map((item: any, index: number) => (
        <CategoryPill key={index} text={item} />
      ))}
    </div>
  );
};

interface TenantProps {
  avatar?: any;
  headline?: any;
  strapline?: any;
  email?: any;
  phone?: any;
  left?: boolean;
  company?: any;
  strapLineItemsList?: any[];
  strapLineItemsListRole?: any;
}

const Tenant: React.FC<TenantProps> = ({
  avatar,
  headline,
  strapline,
  email,
  phone,
  left = false,
  company,
  strapLineItemsList,
  strapLineItemsListRole,
}) => {
  return (
    <div className={'tenant'}>
      {!left && avatar}
      <div className="tenant__details">
        {/* Display person name (headline) first in blue */}
        <div className="tenant__name">{headline}</div>
        {/* Display company name second in black */}
        {company && <div className="tenant__company">{company}</div>}
        {/* Render either pills or original strapline. */}
        {strapLineItemsListRole &&
        strapLineItemsList &&
        strapLineItemsList.length > 0 ? (
          <>
            {strapLineItemsListRole && (
              <div className="tenant__strapline">{strapLineItemsListRole}</div>
            )}
            <CategoryPills items={strapLineItemsList} />
          </>
        ) : (
          strapline && <div className="tenant__strapline">{strapline}</div>
        )}
        {/* Render email and phone fields */}
        {email ? <div>{email}</div> : null}
        {phone ? <div>{onRequestPhoneCall(phone)}</div> : null}
      </div>
      {left && avatar}
    </div>
  );
};

export default Tenant;
